export default "__VITE_ASSET__9pV0jt2f__"